import { gql } from '@apollo/client';

export const UPSERT_GROUP_OPTION = gql`
  mutation upsertGroupOption($input: UpsertGroupOptionInput!) {
    groupOption: upsertGroupOption(input: $input) {
      id
    }
  }
`;
